import styled from 'styled-components';

export const Container = styled.div`
   position: absolute;
    top: -45px;
    left: 0px;
`;

export const BarContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  padding: 2px 2px;
  border-radius: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: fit-content;
`;

export const IconButton = styled.button`
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    border-radius: 30px;
    background-color: #917bf7;  /* 40576d12 grey shade*/
  }

  &:hover .hover-icon g {
    stroke: #fff;
  }

  .hover-icon g {
    stroke: #917bf7;
    transition: background-color .1s linear,border-color .1s linear,color .1s linear;
  }

  .hover-icon:hover g {
    stroke: #fff;
  }
  .close-icon {
    font-size: 12px;
    color: #000;
    &:hover {
      color: #fff;
    }
  }
`;

export const AccessibilityPopupWrapper = styled.div`
  font-family: Open Sans;
  max-width: 225px;
  .label {
    font-size: 14px;
    color: #000;
  }
  .ant-switch {
    margin-right: 4px;
  }
  .ant-switch-checked {
    background: #917bf7 !important;
  }
`;

export const AccessibilityContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 150px;
  width: 100%;
  margin: auto;
  .summary-editor {
    .ql-container {
      border: 1px solid #333;
      border-radius: 6px;
      height: 150px;
      .ql-editor {
        overflow: auto !important;
      }
    }
  }
  .summary-editor-disabled {
    background: #f0f0f0 !important;
    cursor: not-allowed;
    .ql-container {
      border: 1px solid #b8b8b8;
    }
  }
  .summary-save-button {
    margin-top: 8px;
    width:${props => (props.isAltText ? '100%': '49%')};
    background: #917bf7;
    color: #fff;
    font-weight: 700;
    text-align: center;
    padding: 8px 4px;
    border-radius: 6px;
    cursor: pointer; 

    svg{
     width: 16px !important;
     height: 16px !important;
    }
  }
  .summary-clear-button {
    margin-top: 8px;
    width: 49%;
    background: #ab4040;
    color: #fff;
    font-weight: 700;
    text-align: center;
    padding: 8px 4px;
    border-radius: 6px;
    cursor: pointer;

      svg{
     width: 16px !important;
     height: 16px !important;
    }
  }
  .summary-button-parent{
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between;
  }
`;

export const ValidationTitleText = styled.p`
  color: white;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 3px;
`;